import { Component, OnInit, EventEmitter, Output, HostListener, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { WishlistService } from '../wishlist.service';
import { DataCacheService } from '../services/data-cache.service';
import { PartnerService } from '../services/partner.service';
import { ConnectCounsellorComponent } from '../connect-counsellor/connect-counsellor.component';
import { SnackbarService } from '../services/snackbar.service';
import { environment } from 'projects/foreign-admits/src/environments/environment';
import { ConfigService } from 'projects/apna-lib/src/lib/services/config.service';
import { ApiHelperService } from 'projects/apna-lib/src/lib/services/api-helper.service';
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';


function parseDuration(duration: string): number {
  const match = duration.match(/\d+/);
  return match ? parseInt(match[0], 10) : 0;
}


@Component({
  selector: 'app-results',
  templateUrl: './results.component.html',
  styleUrls: ['./results.component.scss']
})


export class ResultsComponent implements OnInit {
  @ViewChild('connectCounsellor') connectCounsellor!: ConnectCounsellorComponent;
  puid: string = "";
  private baseUrl: string = environment.apiBaseUrl;
  @Output() filterApplied: EventEmitter<any> = new EventEmitter<any>();




  // Selected specialization
  selectedSpecialization: string = '';
  specializationSearchTerm: string = '';
  isSpecializationDropdownOpen: boolean = false;
  isSortDropdownOpen: boolean = false;
  sortOptionLabel: string = 'Tuition Fees: High to Low';
  filteredConfig: any[] = []; // Filtered list of courses to display
  isScholarshipFilterEnabled: boolean = false;
  isApplicationFeeWaiverEnabled: boolean = false;
  isEnglishTestWaiverEnabled: boolean = false;
  isLoanOfferEnabled: boolean = false;
  isQSRankingFilterEnabled: boolean = false;

  selectedCoursesForCompare: Set<string> = new Set();
  maxCompareSelection: number = 3;
  minCompareSelection: number = 2;

  config: any[] = [];
  totalUniversities: number = 0;
  message: string = '';
  wishlistLength: number = 0;
  showTooltip: boolean[] = [];
  isLoading: boolean = true;
  wishlist: any[] = [];
  partnerLogo: string = '';
  uniqueUniversitiesCount: number = 0;
  sortOrderKey:
    'high-to-low' |
    'low-to-high' |
    'duration-low-to-high' |
    'duration-high-to-low' |
    'qs-ranking-high-to-low' |
    'qs-ranking-low-to-high' = 'high-to-low';

  marks = ['0', '10', '20', '30', '40', '50', '60', '70', '80', '90', '100'];



  availableSpecializations = this.configService.getConfig1("foreignAssist", "courseFinderAvailableSpecializations");



  courseDuration: string[] = [
    "12 Months", "18 Months", "24 Months", "36 Months", "48 Months",
    "32 Months", "42 Months", "30 Months", "9 Months",
    "47 Months", "24 Months", "6 Months", "36 Months", "15 Months",
    "22 Months", "27 Months", "39 Months", "20 Months",
    "48 Months", "54 Months", "28 Months", "17 Months", "18 Months",
    "16 Months", "25 Months", "10 Months", "60 Months", "19 Months",
    "12 Months", "14 Months", "72 Months", "11 Months", "13 Months",
    "21 Months", "23 Months"
  ];

  countryOptions: { name: string, flagUrl: string }[] = [
    { name: 'US', flagUrl: 'https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1729754442825United%20States%20of%20America%201.png' },
    { name: 'UK', flagUrl: 'https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1729754474318UK-flag.png' },
    { name: 'Canada', flagUrl: 'https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1729754513112Canada-flag.png' },
    { name: 'Germany', flagUrl: 'https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1729754544994germany-flag.png' },
    { name: 'Australia', flagUrl: 'https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1729754573315Australia%201.png' }
  ];

  // public currentPage: number = 1;
  // public itemsPerPage: number = 9;
  isFilterDrawerOpen: boolean = false;
  isWishlistProcessed: boolean = false;

  // Initialize filter object
  initialFilter: any = {
    country: '',
    studyLevel: '',
    course: '',
    tuitionFees: 50000,
    backlogs: 0,
    scholarshipAvailable: false,
    englishTestWaiver: false,
    applicationFeeWaiver: false,
    firstName: '',
    intakeYear: new Date().getFullYear()
  };

  currentFilter: any = { ...this.initialFilter };

  constructor(private router: Router,
    private http: HttpClient,
    public wishlistService: WishlistService,
    private activatedRoute: ActivatedRoute,
    private partnerService: PartnerService,
    private snackbarService: SnackbarService,
    private configService: ConfigService,
    private dataCacheService: DataCacheService,
    private apiHelperService: ApiHelperService) {
    const navigation = this.router.getCurrentNavigation();
    this.config = navigation?.extras?.state?.['data'] || [];
    this.totalUniversities = this.config.length;
    this.showTooltip = new Array(this.config.length).fill(false);

  }

  ngOnInit(): void {
    this.isLoading = true;
    const puid = this.activatedRoute.snapshot.paramMap.get('puid')
    if (puid) {
      this.puid = puid;
      this.fetchPartnerLogo(puid);
    }

    // Add scroll restoration after data is loaded
    Promise.resolve().then(() => {
      const savedPosition = sessionStorage.getItem('lastScrollPosition');
      if (savedPosition) {
        setTimeout(() => {
          window.scrollTo({
            top: parseInt(savedPosition, 10),
            behavior: 'auto'
          });
          sessionStorage.removeItem('lastScrollPosition');
        }, 100);
      }
    });

    const savedFilter = localStorage.getItem('currentFilter');
    const savedSortOption = localStorage.getItem('sortOptionLabel');
    const savedSortKey = localStorage.getItem('sortKey');
    const savedScholarshipFilter = localStorage.getItem('isScholarshipFilterEnabled');
    const savedApplicationFeeWaiverFilter = localStorage.getItem('isApplicationFeeWaiverEnabled');
    const savedEnglishTestWaiverFilter = localStorage.getItem('isEnglishTestWaiverEnabled');
    const savedLoanOfferFilter = localStorage.getItem('isLoanOfferEnabled');
    const savedQSRankingFilter = localStorage.getItem('isQSRankingFilterEnabled');

    // Check if cached results and filters exist
    const cachedResults = this.dataCacheService.getCachedData('results');
    const appliedFilters = localStorage.getItem('appliedFilters');
    const savedInitialFilter = localStorage.getItem('initialFilter');

    if (cachedResults && appliedFilters && savedInitialFilter) {
      console.log('Loading data from local storage cache');
      this.initialFilter = JSON.parse(savedInitialFilter);
      this.config = cachedResults;
      this.filteredConfig = [...this.config];
      this.uniqueUniversitiesCount = this.calculateUniqueUniversities();
      this.currentFilter = JSON.parse(appliedFilters);

      this.sortOptionLabel = savedSortOption || 'Tuition Fees: High to Low';
      this.isScholarshipFilterEnabled = JSON.parse(savedScholarshipFilter || 'false');
      this.isApplicationFeeWaiverEnabled = JSON.parse(savedApplicationFeeWaiverFilter || 'false');
      this.isEnglishTestWaiverEnabled = JSON.parse(savedEnglishTestWaiverFilter || 'false');
      this.isLoanOfferEnabled = JSON.parse(savedLoanOfferFilter || 'false');
      this.isQSRankingFilterEnabled = JSON.parse(savedQSRankingFilter || 'false');

      this.applyLocalFilters();
      if (savedSortKey) {
        this.sortCourses(savedSortKey as any);
      }
      this.restoreScrollPosition();
      this.updateWishlistLength();
      setTimeout(() => {
        this.markCoursesInWishlist();
      }, 1500);
      this.isLoading = false;
    } else {
      setTimeout(() => {
        this.loadStudentDetailsAndFetchResults();

      }, 500);
    }
  }

  @HostListener('window:beforeunload')
  saveScrollPosition() {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    sessionStorage.setItem('lastScrollPosition', scrollPosition.toString());
  }

  // Method to filter courses based on selected filters
  applyLocalFilters(): void {
    this.filteredConfig = this.config.filter(course => {

      let matchesScholarship = true;
      let matchesFeeWaiver = true;
      let matchesEnglishTestWaiver = true;
      let matchesLoanOffers = true;
      let matchesQSRanking = true;

      // Apply scholarship filter if enabled
      if (this.isScholarshipFilterEnabled) {
        matchesScholarship = course.scholarship_available === 'Yes';
      }

      // Apply application fee waiver filter if enabled
      if (this.isApplicationFeeWaiverEnabled) {
        matchesFeeWaiver = course.application_fee === 'Waiver' || course.application_fee === '0';
      }

      if (this.isEnglishTestWaiverEnabled) {
        matchesEnglishTestWaiver = course.english_proficiency_required === 'Yes';
      }

      if (this.isLoanOfferEnabled) {
        matchesLoanOffers = course.loan_offers === 'Yes';
      }
      if (this.isQSRankingFilterEnabled) {
        matchesQSRanking = course.qs_ranking !== null && course.qs_ranking !== undefined && course.qs_ranking !== '';
      }

      return matchesScholarship && matchesFeeWaiver && matchesEnglishTestWaiver && matchesLoanOffers && matchesQSRanking;
    });
    console.log("Filtered Courses:", this.filteredConfig);
    this.uniqueUniversitiesCount = this.calculateUniqueUniversities();
  }


  toggleSortDropdown(event: Event) {
    event.stopPropagation();
    this.isSortDropdownOpen = !this.isSortDropdownOpen;
  }

  // Sort courses by tuition fees
  sortCourses(order: 'high-to-low' | 'low-to-high' | 'duration-low-to-high' | 'duration-high-to-low' | 'qs-ranking-high-to-low' | 'qs-ranking-low-to-high') {
    this.sortOrderKey = order;
    if (order === 'high-to-low') {
      this.filteredConfig.sort((a, b) => b.yearly_tuition_fees - a.yearly_tuition_fees);
      this.sortOptionLabel = 'Tuition Fees: High to Low';
    } else if (order === 'low-to-high') {
      this.filteredConfig.sort((a, b) => a.yearly_tuition_fees - b.yearly_tuition_fees);
      this.sortOptionLabel = 'Tuition Fees: Low to High';
    } else if (order === 'duration-low-to-high') {
      this.filteredConfig.sort((a, b) => parseDuration(a.duration) - parseDuration(b.duration));
      this.sortOptionLabel = 'Duration: Low to High';
    } else if (order === 'duration-high-to-low') {
      this.filteredConfig.sort((a, b) => parseDuration(b.duration) - parseDuration(a.duration));
      this.sortOptionLabel = 'Duration: High to Low';
    } else if (order === 'qs-ranking-high-to-low') {
      this.filteredConfig.sort((a, b) => {
        const aHasRanking = a.qs_ranking !== null && a.qs_ranking !== undefined;
        const bHasRanking = b.qs_ranking !== null && b.qs_ranking !== undefined;

        if (aHasRanking && !bHasRanking) return -1;
        if (!aHasRanking && bHasRanking) return 1;
        if (!aHasRanking && !bHasRanking) return 0;

        // Higher ranking number = lower actual rank, so reverse for "high to low"
        return b.qs_ranking - a.qs_ranking;
      });
      this.sortOptionLabel = 'QS Ranking: High to Low';
    } else if (order === 'qs-ranking-low-to-high') {
      this.filteredConfig.sort((a, b) => {
        const aHasRanking = a.qs_ranking !== null && a.qs_ranking !== undefined;
        const bHasRanking = b.qs_ranking !== null && b.qs_ranking !== undefined;

        if (aHasRanking && !bHasRanking) return -1;
        if (!aHasRanking && bHasRanking) return 1;
        if (!aHasRanking && !bHasRanking) return 0;

        // Lower ranking number = better rank
        return a.qs_ranking - b.qs_ranking;
      });
      this.sortOptionLabel = 'QS Ranking: Low to High';
    }

    this.isSortDropdownOpen = false;
    localStorage.setItem('sortKey', order);


  }

  filteredSpecializations(): any[] {
    if (Array.isArray(this.availableSpecializations) && this.availableSpecializations.length > 0) {
      if (typeof this.availableSpecializations[0] === 'object') {
        return this.availableSpecializations.filter(specialization =>
          specialization.label.toLowerCase().includes(this.specializationSearchTerm.toLowerCase())
        );
      }
      else {
        return this.availableSpecializations.filter(specialization =>
          specialization.toLowerCase().includes(this.specializationSearchTerm.toLowerCase())
        );
      }
    }
    return [];
  }

  toggleSpecializationDropdown() {
    this.isSpecializationDropdownOpen = !this.isSpecializationDropdownOpen;
  }

  // Method to handle specialization selection
  selectSpecialization(specialization: any) {
    // Handle both string and object formats
    if (typeof specialization === 'string') {
      // Old format - string
      this.selectedSpecialization = specialization;
      this.currentFilter.course = specialization;
    } else {
      // New format - object
      this.selectedSpecialization = specialization.label;
      this.currentFilter.course = specialization.value;
    }

    this.specializationSearchTerm = '';
    this.isSpecializationDropdownOpen = false;
  }

  // Add this method in your TypeScript file
  getCountryFlag(countryName: string): string | undefined {
    const country = this.countryOptions.find(c => c.name === countryName);
    return country ? country.flagUrl : undefined;
  }

  fetchPartnerLogo(puid: string): void {
    this.partnerService.getPartnerLogo(puid).then(
      (response) => {
        this.partnerLogo = response.data.company.logo;
      }
    ).catch(
      (error) => {
        console.error('Error fetching partner logo:', error);
      }
    );
  }


  restoreScrollPosition(): void {
    const savedPosition = localStorage.getItem('scrollPosition');
    if (savedPosition) {
      window.scrollTo(0, parseInt(savedPosition));
      localStorage.removeItem('scrollPosition');
    }
  }

  // Load student details and fetch results based on target country, degree, and course
  loadStudentDetailsAndFetchResults(): void {
    const uid = localStorage.getItem('uid');
    const puid = this.activatedRoute.snapshot.paramMap.get('puid');

    if (!uid) {
      console.error('UID not found in local storage');
      return;
    }

    // Get JWT token and validate
    const token = localStorage.getItem('token');
    if (!token) {
      console.error('No access token found');
      this.router.navigate(['/login']);
      return;
    }

    // Create headers with JWT token
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });

    let url = `${this.baseUrl}/student-choices/get-student-details/${uid}`;
    if (puid !== null) {
      url += `/${puid}`;
    } else {
      url += '/null'; // Explicitly send null to backend
    }

    this.apiHelperService.getDataWithShortlistingUrl(url.replace(this.baseUrl + '/', '')).then(
      (response: any) => {
        const studentDetails = response.data;
        console.log('Student Details:', studentDetails);

        // Determine student_percentage and student_backlog based on the type of academicHistory data
        let studentPercentage = null;
        let studentBacklog = 0;

        if (studentDetails.academicHistory?.undergraduateMarks?.percentage) {
          studentPercentage = studentDetails.academicHistory.undergraduateMarks.percentage;
          studentBacklog = studentDetails.academicHistory.undergraduateMarks.degreeBacklogs;
        } else if (studentDetails.academicHistory?.highSchoolMarks?.percentage) {
          studentPercentage = studentDetails.academicHistory.highSchoolMarks.percentage;
          studentBacklog = 0;
        }

        // Create initialFilter with extracted and additional data
        this.initialFilter = {
          country: studentDetails.targetCountry,
          studyLevel: studentDetails.targetDegree,
          course: studentDetails.targetCourse,
          firstName: studentDetails.firstName,
          student_percentage: studentPercentage, // Add student percentage
          student_backlog: studentBacklog,       // Add student backlog
          entryTests: studentDetails.entryTests,
          userId: studentDetails._id,
          puid: puid
        };

        localStorage.setItem('initialFilter', JSON.stringify(this.initialFilter));
        this.currentFilter = { ...this.initialFilter };
        localStorage.setItem('appliedFilters', JSON.stringify(this.currentFilter));
        this.applyFiltersForResult(this.currentFilter);
      }
    ).catch(
      (error) => {
        console.error('Error fetching student details:', error);
      }
    );
  }

  // Apply the filters and fetch results from backend
  applyFiltersForResult(filterData: any): void {
    console.log('Filter Data Applied:', filterData);  // Get JWT token and validate
    const token = localStorage.getItem('token');
    if (!token) {
      console.error('No access token found');
      this.router.navigate(['/login']);
      return;
    }

    // Create headers with JWT token
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });

    this.isLoading = true;
    this.apiHelperService.postDataWithShortlistingUrl('university-courses/receive-data', filterData).then(
      (response: any) => {
        console.log('Filtered Data:', response.data);
        this.config = response.data;
        this.filteredConfig = [...this.config];
        this.uniqueUniversitiesCount = this.calculateUniqueUniversities();
        this.dataCacheService.setCachedData('results', response.data);
        this.updateWishlistLength();

        this.isLoading = false;
      }
    ).catch(
      (error) => {
        console.error('Error applying filters:', error);
        this.isLoading = false;
      }
    );
  }


  updateResults(newConfig: any[]) {
    this.config = newConfig;
    this.totalUniversities = this.config.length;
    // this.currentPage = 1;
  }

  viewDetails(course: any) {
    const puid = this.activatedRoute.snapshot.paramMap.get('puid');
    console.log(puid, 49)
    console.log(course.course_id, 50)
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    sessionStorage.setItem('lastScrollPosition', scrollPosition.toString());

    // Save the current filter state to local storage
    localStorage.setItem('currentFilter', JSON.stringify(this.currentFilter));
    localStorage.setItem('sortOptionLabel', this.sortOptionLabel);
    localStorage.setItem('isScholarshipFilterEnabled', JSON.stringify(this.isScholarshipFilterEnabled));
    localStorage.setItem('sortKey', this.sortOrderKey); // ADD HERE
    localStorage.setItem('isApplicationFeeWaiverEnabled', JSON.stringify(this.isApplicationFeeWaiverEnabled));
    localStorage.setItem('isEnglishTestWaiverEnabled', JSON.stringify(this.isEnglishTestWaiverEnabled));
    localStorage.setItem('isLoanOfferEnabled', JSON.stringify(this.isLoanOfferEnabled));
    localStorage.setItem('isQSRankingFilterEnabled', JSON.stringify(this.isQSRankingFilterEnabled));

    // const navigationExtras = {
    //   queryParams: { course_id: course.course_id },
    //   state: { origin: 'results' } // Specify the origin as 'results'
    // };

    if (puid) {
      this.router.navigate(['/university-detail', course.course_id, puid]);
    } else {
      this.router.navigate(['/university-detail', course.course_id]);
    }
  }

  addToWishlist(course: any) {
    if (this.wishlistLength >= 30) {
      console.error('You cannot shortlist more than 30 courses.');
      this.snackbarService.show('You cannot shortlist more than 30 courses.', 'warning');
      return;
    }

    const puid = this.activatedRoute.snapshot.paramMap.get('puid');

    // Include puid in the course object to send to the service
    const courseWithPartner = {
      ...course,
      partnerId: puid
    };

    this.wishlistService.addToWishlist(courseWithPartner).subscribe(
      (response: any) => {
        console.log('Course added to wishlist:', response);
        course.isInWishlist = true;
        this.updateWishlistLength();

      },
      (error) => {
        console.error('Error adding course to wishlist:', error);
        if (error?.status === 409) {
          this.snackbarService.show('Course already exists in your wishlist.', 'warning');
        } else {
          this.snackbarService.show('Failed to add the course to your wishlist. Please try again.', 'error');
        }
      }
    );
  }


  viewWishlist() {

    const puid = this.activatedRoute.snapshot.paramMap.get('puid');
    console.log(puid, 76)

    if (puid) {
      this.router.navigate(['/wishlist/' + puid]);
    }
    else {
      this.router.navigate(['/wishlist']);
    }
  }

  toggleTooltip(index: number, show: boolean) {
    this.showTooltip[index] = show;
  }


  // Function to update wishlist length
  updateWishlistLength() {
    const token = localStorage.getItem('token');
    const uid = localStorage.getItem('uid');

    if (!uid) {
      console.error('No UID found in local storage');
    }

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'uid': uid
    });

    this.wishlistService.getWishlist(headers).subscribe(
      (response: any) => {
        if (response && response.data) {
          this.wishlistLength = response.data.length;
          console.log('Wishlist Length:', this.wishlistLength);
          this.isLoading = false;
        } else {
          this.wishlistLength = 0;
          this.isLoading = false;
        }
      },
      (error) => {
        console.error('Error fetching wishlist:', error);
        this.wishlistLength = 0;
        this.isLoading = false;
      }
    );
  }



  viewProfile() {
    const puid = this.activatedRoute.snapshot.paramMap.get('puid');
    console.info(puid, 123)
    let isApplicant = this.getStudentApplicantStatus()
    console.info(isApplicant, 541)
    if (isApplicant) {
      if (puid) {
        this.router.navigate(['/student-dashboard/' + puid]);
      }
      else {
        this.router.navigate(['/student-dashboard']);
      }

    } else {
      if (puid) {
        this.router.navigate(['/personal-details/' + puid]);
      }
      else {
        this.router.navigate(['/personal-details']);
      }
    }
  }

  private getStudentApplicantStatus() {
    const uid = localStorage.getItem('uid');
    const token = localStorage.getItem('token');

    if (!uid || !token) {
      console.error('Missing UID or token');
      return of(false);
    }

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });

    return this.apiHelperService.getDataWithShortlistingUrl(`student-choices/student-applicant-status/${uid}`).then(
      (res: any) => {
        if (typeof res === 'boolean') return res;
        if (res?.data?.status !== undefined) return !!res.data.status;
        if (res?.status !== undefined) return !!res.status;
        return false;
      }
    ).catch(err => {
      console.error('Error checking student applicant status:', err);
      return false;
    });
  }



  // Pagination methods
  // public get totalPages(): number {
  //   return Math.ceil(this.config.length / this.itemsPerPage);
  // }

  // public nextPage(): void {
  //   if (this.currentPage < this.totalPages) {
  //     this.currentPage++;
  //   }
  // }

  // public previousPage(): void {
  //   if (this.currentPage > 1) {
  //     this.currentPage--;
  //   }
  // }

  // public goToPage(pageNumber: number): void {
  //   if (pageNumber >= 1 && pageNumber <= this.totalPages) {
  //     this.currentPage = pageNumber;
  //   }
  // }

  // Toggle filter drawer
  toggleFilterDrawer(): void {
    this.isFilterDrawerOpen = !this.isFilterDrawerOpen;

  }

  // Apply advance filters logic
  applyFilters(): void {

    if (this.currentFilter.studyLevel === 'Bachelors') {
      this.currentFilter.studyLevel = 'Undergraduate';
    } else if (this.currentFilter.studyLevel === 'Masters') {
      this.currentFilter.studyLevel = 'Postgraduate';
    }

    console.log('Applying filters:', this.currentFilter);

    this.applyFiltersToData(this.currentFilter);
    this.isFilterDrawerOpen = false;
  }

  applyFiltersToData(filterData: any): void {
    console.info('Filter Data Applied:', filterData);
    localStorage.setItem('appliedFilters', JSON.stringify(filterData));
    this.isLoading = true;
    this.apiHelperService.postDataWithShortlistingUrl('university-courses/apply-filters', filterData).then(
      (response: any) => {
        console.info('Filtered Data:', response.data);
        this.config = response.data;
        this.filteredConfig = [...this.config];
        this.uniqueUniversitiesCount = this.calculateUniqueUniversities();
        this.dataCacheService.setCachedData('results', response.data);
        this.filterApplied.emit(this.config);
        this.isLoading = false;
      }
    ).catch(
      (error) => {
        console.error('Error applying filters:', error);
        this.isLoading = false;
      }
    );
  }


  // Function to update wishlist and wishlist length
  updateWishlist() {
    const token = localStorage.getItem('token');
    const uid = localStorage.getItem('uid');

    if (!uid) {
      console.error('No UID found in local storage');
    }

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'uid': uid
    });

    this.wishlistService.getWishlist(headers).subscribe(
      (response: any) => {
        if (response && response.data) {
          this.wishlist = response.data;
          this.wishlistLength = this.wishlist.length;
          this.config.forEach(course => {
            course.isInWishlist = this.wishlist.some(wish => wish.courseId === course.course_id);
          });

          console.log('Wishlist Length:', this.wishlistLength);
          this.isLoading = false;
        } else {
          this.wishlistLength = 0;
          this.isLoading = false;
        }
      },
      (error) => {
        console.error('Error fetching wishlist:', error);
        this.wishlistLength = 0;
        this.isLoading = false;
      }
    );
  }

  // Fetch wishlist and mark courses already in it
  markCoursesInWishlist() {
    const token = localStorage.getItem('token');
    const uid = localStorage.getItem('uid');

    if (!uid) {
      console.error('No UID found in local storage');
    }

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'uid': uid
    });

    this.wishlistService.getWishlist(headers).subscribe(
      (response: any) => {
        const wishlist = response.data;

        console.log('Wishlist:', wishlist);
        console.log('Config:', this.config);

        this.config.forEach(course => {
          course.isInWishlist = wishlist.some((wish: any) => String(wish.courseId) === String(course.course_id));
        });
        this.isWishlistProcessed = true;
      },
      (error) => {
        console.error('Error fetching wishlist:', error);
        this.isWishlistProcessed = true;
      }
    );
  }

  // Open the Connect to Counsellor modal
  openConnectModal() {
    this.connectCounsellor.openModal();
  }

  // Handle successful request submission
  onRequestSubmitted() {
    console.log('Counsellor request submitted successfully!');
  }

  calculateUniqueUniversities(): number {
    const uniqueUniversities = new Set(
      this.filteredConfig.map(course => course.university)
    );
    return uniqueUniversities.size;
  }

  updateSliderBackground(event: Event) {
    const input = event.target as HTMLInputElement;
    const value = (Number(input.value) / Number(input.max)) * 100;
    input.style.setProperty('--value', `${value}%`);
  }


  toggleCourseForCompare(course: any, event: Event): void {
    event.stopPropagation(); // Prevent card click navigation
    
    const courseId = course.course_id;
    if (this.selectedCoursesForCompare.size >= 3) {
        this.snackbarService.show(`You can only select up to 3 courses for comparison.`, 'warning');
  
        return;
      }
    
    if (this.selectedCoursesForCompare.has(courseId)) {
      // Remove from selection
      this.selectedCoursesForCompare.delete(courseId);
    } else {
      // Check if we can add more courses (max 3 allowed)
      if (this.selectedCoursesForCompare.size >= this.maxCompareSelection) {
        this.snackbarService.show(`You can only select up to 3 courses for comparison.`, 'warning');
  
        return;
      }
      
      // Add to selection
      this.selectedCoursesForCompare.add(courseId);
    }
    
    console.log('Selected courses for compare:', Array.from(this.selectedCoursesForCompare));
  }

  /**
   * Check if a course is selected for comparison
   */
  isCourseSelectedForCompare(courseId: string): boolean {
    return this.selectedCoursesForCompare.has(courseId);
  }

  /**
   * Get count of selected courses
   */
  getSelectedCompareCount(): number {
    return this.selectedCoursesForCompare.size;
  }

  /**
   * Navigate to compare page with selected courses
   */
  navigateToCompare(): void {
    if (this.selectedCoursesForCompare.size < this.minCompareSelection) {
      this.snackbarService.show(`Please select at least ${this.minCompareSelection} courses to compare.`, 'warning');
      return;
    }

    const selectedCourseIds = Array.from(this.selectedCoursesForCompare);
    const puid = this.activatedRoute.snapshot.paramMap.get('puid');
    
    // Save current state before navigation
    this.saveCurrentState();
    
    // Navigate with course IDs as query parameters
    const queryParams = {
      courses: selectedCourseIds.join(',')
    };
    
    if (puid) {
      this.router.navigate(['/compare', puid], { queryParams });
    } else {
      this.router.navigate(['/compare'], { queryParams });
    }
  }

  /**
   * Clear all selected courses for comparison
   */
  clearCompareSelection(): void {
    this.selectedCoursesForCompare.clear();
  }

  /**
   * Save current state for navigation return
   */
  private saveCurrentState(): void {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    sessionStorage.setItem('lastScrollPosition', scrollPosition.toString());
    
    localStorage.setItem('currentFilter', JSON.stringify(this.currentFilter));
    localStorage.setItem('sortOptionLabel', this.sortOptionLabel);
    localStorage.setItem('isScholarshipFilterEnabled', JSON.stringify(this.isScholarshipFilterEnabled));
    localStorage.setItem('isApplicationFeeWaiverEnabled', JSON.stringify(this.isApplicationFeeWaiverEnabled));
    localStorage.setItem('isEnglishTestWaiverEnabled', JSON.stringify(this.isEnglishTestWaiverEnabled));
    localStorage.setItem('isLoanOfferEnabled', JSON.stringify(this.isLoanOfferEnabled));
  }


}
